module.exports = __webpack_public_path__ + "img/commercial-projects.5a2b7976.png";